<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="5">
					<!-- 품번 -->
					<search-input
						:label="getMessage_('QWCC000956')"
						paramKey="partNo"
						@commInput="setSearchParam"
						:propData="searchCommParams.partNo"
						:readonly="true"
					>
					</search-input>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="searchList" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/PartCku/store/helpers';
import SearchInput from '@qms/Components/SearchInput';

export default {
	props: {
		scrId: { type: String, default: '' },
		partNo: { type: String, default: '' }
	},
	components: {
		SearchInput
	},
	created() {
		//console.log('create search >>>>>', this.partNo);
		this.searchCommParams.partNo = this.partNo;
		this.searchList();
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		searchList() {
			// console.log('PqPartPopupSearch 에서 searchList 실행>>>', this.searchDtlParams);
			// console.log('searchList >>>>>', this.propPartNo);
			this.$sf_toggleLoading(true);
			this.getPartPopupCommResults_(this.searchCommParams)
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
					this.$sf_toggleLoading(false);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		setSearchParam({ key, value }) {
			this.searchCommParams[key] = value;
		},
		resetParam(param) {
			//console.log('reset >>> ', param);
			//this.partNo = param ? param : '';
			this.searchCommParams.partNo = param ? param : '';
		}
	}
};
</script>

<style></style>
